export const API_BASE_URL =
  import.meta.env.VITE_APP_API_BASE_URL ?? 'http://localhost:8080/management-api/v1'
export const CODES_API_BASE_URL =
  import.meta.env.VITE_APP_CODES_API_BASE_URL ?? 'http://localhost:8080/api/v1/_codes'
export const SECRETS_API_BASE_URL =
  import.meta.env.VITE_APP_SECRETS_API_BASE_URL ?? 'http://localhost:8080/api/v1/_secrets'
